(function ($, undefined) {
	"use strict";

	let utils;
	let formValidator;
	let locationsUtils;

	function init() {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;

		const form = $('#location-form-info, .wizard_step2 .wizard__questions');
		$('.add-location-info__add').on('click', onClickAdd);
		$('.add-location-info-block__delete').on('click', onClickDelete);
		$('.add-location-info__blocks').on('change', '[name=title]', onLocationInfoBlockTitleChange);
		$(form).on('submit', onFormSubmit);
		$('.select-state-input, .select-country-input', form).on('select2:select', getCitiesIfNecessary);
		$('[name="field2"]', form).on('keyup', onKeyupName);
		$('#buttonRemoveResources').on('click', removeResources);

		/*code by younis*/
		$('#add-new-location-overview-form-btn').on('click', onAddNewOverviewItem);
		$('.btn.submit-location-overview-form').on('click', onSaveLocationOverviews);
		/*end code by younis*/
	}

	/*code by younis*/
	function onAddNewOverviewItem() {
		var list = $('.location-overview-items-list');
		var item = $('.location-overview-item', list).first().clone(true);
		var newId = $('.location-overview-item', list).length + 1;
		var textarea = $('textarea', item);
		item.find('.mce-container').remove();
		textarea.removeAttr('style');
		textarea.attr('id', textarea.attr('id') + Math.floor(Math.random() * 10000000));
		$('input, select, textarea', item).val("");
		$('input, select, textarea', item).removeClass("error");
		$('.location-overview-item__delete-btn', item).show();
		$('.location-overview-item__delete-btn', item).attr('data-item-id', newId);
		item.attr('data-id', "location-overview-item-" + newId);

		list.append(item);
		utils.initTinyMCE(textarea.get(0));
		window.parent.updateHiddenSelect(item,newId);
	}


	function reOrderItems() {
		var list = $('.location-overview-items-list');
		$('.location-overview-item', list).each((i, el) => {
			var newId = i + 1;
			$(el).attr("data-id", "location-overview-item-" + newId);
			$('.location-overview-item__delete-btn', el).attr('data-item-id', newId);
		});
	}

	function onSaveLocationOverviews() {
		var form = $('#overviewForm');
		var list = $('.location-overview-items-list', form);
		var overviewsListItems = $('.location-overview-item', list);
		
		formValidator.validateForm(form);
		console.warn(form.hasClass('has-error'));
		if (!form.hasClass('has-error')) {
			locationsUtils.addOverlay();
			var overviewsArray = [];
			overviewsListItems.each((i, el) => {
				let textarea = el.querySelector('textarea');
				let description = textarea.value;
				try { description = tinymce.get(textarea.id).getContent() } catch (ex) { /* Voluntarily do nothing */ }
				overviewsArray.push({
					"title": $('[name=title]', el).val(),
					"description": description
				});
			});
			const data = {
				id: form.find('[name="id"]').val(),
				field14: JSON.stringify(overviewsArray)
			};
			locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
				if (id != null) {
					form.find('[name="id"]').val(id);
					showMessage(form, '_success.overview');
					form.find('.add-location-info__client_hidden')
						.removeClass('add-location-info__client_hidden')
						.find('input')
						.val(id);
				} else
					showMessage(form, '_server.overview');

				locationsUtils.removeOverlay();
			});
		}
	}

	function showMessage(form, modifier) {
		$(`.form-message${modifier}`, form).show();
	}

	function hideMessage(form, modifier) {
		$(`.form-message${modifier}`, form).hide();
	}
	/*end code by younis*/

	function onClickAdd({ currentTarget }) {
		const blocks = currentTarget.previousElementSibling;
		var template = document.getElementById('add-location-optional-info');
		const clone = template.cloneNode(true);
		const textarea = clone.querySelector('textarea');
		const select = clone.querySelector('select');
		const btn = clone.querySelector('button');

		select.classList.add('required');
		btn.addEventListener('click', onClickDelete);
		textarea.id = "description" + Math.floor(Math.random() * 10000000);
		blocks.appendChild(clone);
		utils.initTinyMCE(textarea);

		window.parent.updateHiddenSelect(clone,(Math.floor(Math.random() * 10000000)));
		clone.removeAttribute('id');
		clone.classList.remove('add-location-info__block_template');
	}

	function removeResources({ currentTarget }) {
		const form = $('#location-form-info, .wizard_step2 .wizard__questions');
		const data = {
			id: form.find('[name="id"]').val(),
			field20: '',
		};
		form.find('[name="field20"]').val("");
		
		function callback(id) {
			form.find('[name="id"]').val(id);
			showMessage(form, '_success.infos');
			form.find('.add-location-info__client_hidden')
				.removeClass('add-location-info__client_hidden')
				.find('input')
				.val(id);
			const img = $('.add-location-info__image');
			const uploadBtn = $('.upload-input__bottom');
			const removeButton = $('.add-location-info__upload-remove');
			img.addClass('add-location-info__image_hide');
			uploadBtn.removeClass('upload-input__bottom_hide');
			removeButton.addClass('add-location-info__upload-remove_hide');
		}
		// Make a case for the wizard
		// because it doesnt have to update a location
		// Hence: He doesnt have an ID
		const isInWizard = $(currentTarget).closest('.wizard_step2').length > 0;
		if (isInWizard) {
			callback(-1);
		} else {
			locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
				if (id != null) {
					callback(id);
				} else
					showMessage(form, '_server.infos');

				locationsUtils.removeOverlay();
			});
		}
	}

	function onClickDelete({ currentTarget }) {
		const block = utils.getClosest(currentTarget, '.add-location-info-block');
		block.parentNode.removeChild(block);
	}

	function onKeyupName({ currentTarget }) {
		$('.side-menu-page__subtitle').text(currentTarget.value);
	}

	function onFormSubmit(e) {
		const form = $(e.currentTarget);

		if (form.hasClass('wizard__questions')) {
			return;
		}

		e.preventDefault();

		hideMessage(form, '.infos');

		formValidator.validateForm(form)
		locationsUtils.addOverlay();
		
		if (!form.hasClass('has-error')) {
			const info = { information: locationsUtils.parseInfo() };
			const data = {
				id: form.find('[name="id"]').val(),
				field1: 'location',
				field2: form.find('[name="field2"]').val(),
				field3: JSON.stringify(info),
				field4: form.find('[name="field4"]').val(),
				field5: form.find('[name="field5"]').val(),
				field6: form.find('[name="field6"]').val(),
				field7: form.find('[name="field7"]').val(),
				field8: form.find('[name="field8"]').val(),
				field9: form.find('[name="field9"]').val(),
				field10: form.find('[name="field10"]').val(),
				field20: form.find('[name="field20"]').val(),
			};

			const images = $('[name="resources"]').get(0).files;

			utils.uploadSecureFiles(images, (json) => {
				if (json && json.hasOwnProperty('media') && json.media.hasOwnProperty('mediaIds')) {
					const mediaId = json.media.mediaIds[0].split(" - ")[0];
					const img = $('.add-location-info__image');
					const uploadBtn = $('.upload-input__bottom');
					const removeButton = $('.add-location-info__upload-remove');
					data.field20 = mediaId;
					img.attr('src', `${img.attr('data-url')}${mediaId}`).removeClass('add-location-info__image_hide');
					uploadBtn.addClass('upload-input__bottom_hide');
					removeButton.removeClass('add-location-info__upload-remove_hide');
				}
				locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
					if (id != null) {
						form.find('[name="id"]').val(id);
						showMessage(form, '_success.infos');
						form.find('.add-location-info__client_hidden')
							.removeClass('add-location-info__client_hidden')
							.find('input')
							.val(id);
					} else
						showMessage(form, '_server.infos');

					locationsUtils.removeOverlay();
				});
			}, null, "image", utils.UPLOAD_KEY);
		} else {
			locationsUtils.removeOverlay();
		}
	}



	function getCitiesIfNecessary() {
		
		const countrySelect = $('.updated-select-input.select-country-input');
		const stateSelect = $('.updated-select-input.select-state-input:not([disabled])');
		const citySelect = $('#add-location-info-city');
		const set = new Set();
		
		// citySelect.val("");

		if (countrySelect.length && stateSelect.length) {
			citySelect.addClass('has-processing has-processing_active');
			$.ajax({
				url: '/action/fetchGenData',
				type: 'GET',
				dataType: 'json',
				data: {
					field1: 'geolocation',
					field2: countrySelect.find(":selected").val(),
					field3: stateSelect.find(":selected").val(),
				}
			}).then(res => {
				if (typeof res === 'string' || res.length == 0) {
					disableCitySelect();
					return;
				}
				res.sort((locA, locB) => {
					if (locA.field4 < locB.field4) {
						return -1;
					} else if (locA.field4 > locB.field4) {
						return 1;
					} else {
						return 0;
					}
				}).forEach(geoloc => {
					set.add(geoloc.field4);
				});

				citySelect.find('option:not([value=""])').remove();

				set.forEach(city => {
					citySelect.append(`<option>${city}</option>`);
				});

				citySelect.removeAttr('disabled');
				citySelect.removeClass('has-processing has-processing_active');

				citySelect.parent().find(".select2.select2-container.select2-container--default").remove(); 
				citySelect.select2({
					sorter: data => {
					  var firstItem=data.shift();
					  
					  var tempData=data.sort((a, b) =>a.text.localeCompare(b.text));
					  tempData.unshift(firstItem);
					  return tempData;
					} 
				  });
				
				var container=$(citySelect).siblings('.select2-container');
			
				container.css({'display':'block','max-width':'100%','width':'100%','min-width':'100%'});
				
				$(container).find(".select2-selection").css({'height': '47px','border': '1px solid #cbccd9',
				'background-color':'inherit','font-size': '1.4rem',
				'font-family': 'Lato,arial,helvetica,sans-serif'});
				$(container).find('.select2-selection__arrow').css({'height': '44px','right':'10'});
				$(container).find('.select2-selection__rendered').css({'line-height': '44px','padding-left':'18px'});

			}).catch(ex => {
				disableCitySelect();
			});
		} else {
			disableCitySelect();
		}
	}

	function disableCitySelect() {
		const citySelect = $('#buttons-filter-city-select');
		citySelect.val('');
		citySelect.attr('disabled', 'disabled');
		citySelect.removeClass('has-processing has-processing_processing');
	}

	function onLocationInfoBlockTitleChange() {
		var select = $(this);
		var ctn = select.closest('.add-location-info-block');
		var title = select.val();

		if (title === "email" || title === "phone") {
			$('.add-location-info-block__text-ctn', ctn).addClass('add-location-info-block__text-ctn_hide');
			$('.add-location-info-block__input-ctn', ctn).removeClass('add-location-info-block__input-ctn_hide');

			$('.add-location-info-block__input-ctn input[name=description]', ctn).attr("type", title === "email" ? "email" : "tel");
			$('.add-location-info-block__input-ctn input[name=description]', ctn).attr("placeholder", title === "email" ? "Email" : "Phone");
			var inputs=$('.add-location-info-block__input-ctn', ctn).find("input");
			if(inputs!=undefined && inputs.length>0)
				inputs.each((i,v)=>{$(v).val("");});
		} else {
			$('.add-location-info-block__text-ctn', ctn).removeClass('add-location-info-block__text-ctn_hide');
			$('.add-location-info-block__input-ctn', ctn).addClass('add-location-info-block__input-ctn_hide');

			var inputs=$('.add-location-info-block__text-ctn', ctn).find("textarea");
			if(inputs!=undefined && inputs.length>0)
				inputs.each((i,v)=>{$(v).text("");});
		}
	}


	$(init);
	Fw.component.export('locationOverviewUtils', {
		reOrderItems
	});
})(jQuery);